// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IVMEg3n0FvuPK3ZQhh4A {
    display: flex;
    align-items: center;
    margin-left: 16px;
}

.dTn38ofqQDNEynXh59Lv {
    margin: 0 8px;
}

.IVMEg3n0FvuPK3ZQhh4A > button + button {
    margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-profile/components/navigation.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    margin-left: 16px;\n}\n\n.offsets {\n    margin: 0 8px;\n}\n\n.container > button + button {\n    margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IVMEg3n0FvuPK3ZQhh4A`,
	"offsets": `dTn38ofqQDNEynXh59Lv`
};
export default ___CSS_LOADER_EXPORT___;
